import { ICONS } from "@/modules/ui-elements/Icon";
import { useDispatch } from "react-redux";
import { setBulkUplodAIType } from "@/redux/reducers/file-upload.reducer";
import { BULK_AI_TYPE } from "@/utils/toolsConstants";
import { useSelector } from "react-redux";
import styles from "../AIBackgrounds/styles.module.css";
import { TrackWebappEvent } from "@/modules/segment-event-tracking/segmentEventTracking";
import { EventTrackName } from "@/modules/segment-event-tracking/constant";
import { useAtomValue } from "jotai";
import { segmentEventPayload } from "@/modules/editor-v2/Atoms";

const Index = ({popUpRef}) => {
  const dispatch = useDispatch();
  const {BulkUploadAIScreen} = useSelector((state) => state?.strapi?.entireStrapiData);
  const strapiData = BulkUploadAIScreen?.BulkUploadAIScreen;

  const optionList = [
    { title: strapiData?.ModelAIHeader || "Showcase Product in Context", isActive: true, type:BULK_AI_TYPE.BULK_UPLOAD_GENAI,modelType:"product in context",icon:ICONS.productLifestyle,image:'/icons/lifestyle.png'},
    { title: strapiData?.FaceSwapHeader || "Refresh Model Imagery", isActive: true, type:BULK_AI_TYPE.BULK_UPLOAD_FACE_SWAP,modelType:"model swap",icon:ICONS.modelGeneration,image:'/icons/face-swap.png'},
    { title: strapiData?.ModelSwapHeader || "Generate Model in Context", isActive: true, type:BULK_AI_TYPE.BULK_UPLOAD_MODEL_GEN,modelType:"model generation",icon:ICONS.faceSwap,image:'/icons/model-gen.png'},
  ];
    const getSegmentPayloadAtom = useAtomValue(segmentEventPayload);

  const showFileUploadDialog = (item) => () => {
    if(!item.isActive)return;
    dispatch(setBulkUplodAIType(item.type));
    const eventPayload = {
      homepageFeature: item.type == 'BULK_UPLOAD_GENAI' ? 'product in context'
      : item.type == 'BULK_UPLOAD_FACE_SWAP' ? 'model swap'
      : 'model generation',
      ...getSegmentPayloadAtom,
    };
    TrackWebappEvent(
      `${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._select_tool_hp}`,
      eventPayload
    );
    popUpRef.current.open({
      title: item?.title,
      batchAI:true,
    });
  };

  return (<>
          {optionList.map((item) => (
            <div
              className={styles.listItem}
              onClick={showFileUploadDialog(item)}
            >
              <img
                src={item.image}
                className={styles.listImage}
              />
              <div className={styles.listItemTitleContainer}>
                <div className={styles.listItemTitle}>
                  <span>{item.title}</span>
                  <img src={ICONS.rightArrowVector} style={{ color: '#FFFFFF !important' }} alt="" height={10} />
                </div>
              </div>
            </div>
          ))}
        </>)
};

export default Index;
